module.exports = __webpack_public_path__ + "img/img_back_babyblue.41f1bfff.png";